import React from "react";
import { PageHeader } from "@/components/PageHeader";
import { Card } from "@/components/ui/card";
import { Link } from "react-router-dom";
import { InfoIcon, GearIcon } from "@phosphor-icons/react";

export default function Settings() {
  return (
    <div>
      <PageHeader
        overline="Admin"
        title="Settings"
        description="India tax defaults and pointers to the full Admin Console."
      />

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <Card className="p-6 lg:col-span-2">
          <div className="flex items-start gap-3">
            <InfoIcon size={22} className="text-primary mt-1" weight="duotone" />
            <div>
              <p className="label-overline">Configuration moved</p>
              <h3 className="font-display text-2xl mt-1">Everything now lives in Admin Console</h3>
              <p className="text-sm text-muted-foreground mt-2 max-w-lg">
                Payments are recorded manually (cash / UPI / card / bank) from the Invoices page — no gateway
                keys required. Email, WhatsApp, OTA credentials, GSTIN and invoice defaults are all managed
                in the Admin Console.
              </p>
              <Link
                to="/admin"
                className="inline-flex items-center gap-1 mt-4 text-sm text-primary hover:underline"
                data-testid="settings-open-admin"
              >
                <GearIcon size={14} /> Open Admin Console
              </Link>
            </div>
          </div>
        </Card>

        <Card className="p-6">
          <p className="label-overline">Tax & Currency</p>
          <h3 className="font-display text-xl mt-1">India defaults</h3>
          <div className="mt-4 space-y-3 text-sm">
            <div className="flex justify-between border-b border-border/60 pb-2"><span className="text-muted-foreground">Currency</span><span>INR (₹)</span></div>
            <div className="flex justify-between border-b border-border/60 pb-2"><span className="text-muted-foreground">Tax (GST)</span><span>12% on room (editable per invoice)</span></div>
            <div className="flex justify-between"><span className="text-muted-foreground">Region</span><span>Gangtok, Sikkim</span></div>
          </div>
        </Card>
      </div>
    </div>
  );
}
